// 运行时配置
import '@/assets/fonts/font.css';
import '../global.less';
// 运行时配置
import { RequestConfig, RequestOptions } from '@umijs/max';

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<{ name: string }> {
  return { name: '@umijs/max' };
}

export const layout = () => {
  return {
    logo: 'https://img.alicdn.com/tfs/TB1YHEpwUT1gK0jSZFhXXaAtVXa-28-27.svg',
    menu: {
      locale: false,
    },
  };
};

/**
 * api拦截器
 */
export interface IRequestResult {
  msg: string;
  code: number;
  body: any;
}
export const request: RequestConfig = {
  // 配置 API 基础 URL，参考 cngzc-jituan 项目配置方式
  // 前后端在同一服务器，使用相对路径
  baseURL: '/cnzgc',
  timeout: 20000,
  // 是否跨站点访问控制请求
  withCredentials: true,
  errorConfig: {
    errorHandler: (error: any) => {
      console.log('请求错误:', error);
    },
    errorThrower: (error: any) => {
      console.log('errorThrower:', error);
    },
  },
  requestInterceptors: [
    (url: any, options: RequestOptions) => {
      options.headers = {
        ...options.headers,
        'x-homepage-header': 'homePage',
      };
      return { url, options };
    },
  ],
  // 响应拦截器
  responseInterceptors: [
    (response: any) => {
      return {
        data: {
          data: response.data,
        },
      };
    },
  ],
};
